// extracted by mini-css-extract-plugin
export default {"newsletter":"css-l9rKLgpv0W","newsletter_form":"css-Xw-WHcdIqN"};